<div class="sdc-statuses-container">
  <ng-container *ngFor="let widget of widgets">
    <div class="sdc-status"
         [ngClass]="widget.cssClass"
         container="body"
         [tooltip]="widget.tooltip | translate">
      <span class="state">{{ widget.label | translate }}<sup *ngIf="widget.versionTag">{{ widget.versionTag }}</sup> {{ widget.state | translate }}</span>
    </div>
  </ng-container>
</div>
